import { useState, useEffect, type Dispatch, type SetStateAction } from 'react';
import type { FreeStatus } from '../types';

export const useFreeStatus = (clientMac: string): [FreeStatus, Dispatch<SetStateAction<FreeStatus>>] => {
  const [free, setFree] = useState<FreeStatus>({ status: 'checking' });

  useEffect(() => {
    if (!clientMac) { setFree({ status: 'available' }); return; }
    setFree({ status: 'checking' });
    fetch(`/auth/status?clientMac=${encodeURIComponent(clientMac)}`)
      .then(r => r.json())
      .then(setFree)
      .catch(() => setFree({ status: 'available' }));
  }, [clientMac]);

  useEffect(() => {
    if (free.status !== 'cooldown') return;
    const id = setInterval(() => {
      setFree(prev => {
        if (prev.status !== 'cooldown') return prev;
        const remaining = prev.remaining - 1000;
        return remaining > 0 ? { ...prev, remaining } : { status: 'available' };
      });
    }, 1000);
    return () => clearInterval(id);
  }, [free.status]);

  return [free, setFree];
};
